import { FC } from 'react';
import { RouteComponentProps } from 'react-router-dom';

import Test from 'routes/test';
import Login from 'routes/auth/login';
import Logout from 'routes/auth/logout';
import NotFound from 'routes/404';
import Activate from 'routes/auth/activate-account';
import NotAuthorized from 'routes/not-authorized';
import PasswordReset from 'routes/auth/password-reset';
import ProfileSettings from 'routes/profile/settings';
import ForgottenPassword from 'routes/auth/forgotten-password';
import TwoFactorAuthSettings from 'routes/profile/2fa-settings';
import TwoFactorAuthActivate from 'routes/profile/2fa-activate';
import ClearCacheComponent from 'routes/client/clear-state';
import CandidateApplication from 'routes/auth/candidate-application';

export interface IRouteConfig {
  path: string;
  isExact: boolean;
  isPrivate: boolean;
  is2FaProtected: boolean;
  component: FC<RouteComponentProps>;
  isProvidingClient?: boolean;
  permissionGrantingAccess?: string;
}

const routes: IRouteConfig[] = [
  {
    path: '/',
    isExact: true,
    isPrivate: false,
    is2FaProtected: false,
    component: Login,
  },
  {
    path: '/forgotten-password',
    isExact: true,
    isPrivate: false,
    is2FaProtected: false,
    component: ForgottenPassword,
  },
  {
    path: '/new',
    isExact: true,
    isPrivate: false,
    is2FaProtected: false,
    component: CandidateApplication,
  },
  {
    path: '/account-activation/:confirmationToken',
    isExact: true,
    isPrivate: false,
    is2FaProtected: false,
    component: Activate,
  },
  {
    path: '/password-reset/:passwordResetToken',
    isExact: true,
    isPrivate: false,
    is2FaProtected: false,
    component: PasswordReset,
  },
  {
    path: '/test',
    isExact: true,
    isPrivate: true,
    is2FaProtected: true,
    component: Test,
  },
  {
    path: '/logout',
    isExact: true,
    is2FaProtected: false,
    isPrivate: false, // We have an edge case where we redirect to logout after tokens are removed from store
    component: Logout, // to prevent infinite loops after both access and refresh tokens expire
  },
  {
    path: '/profile/settings',
    isExact: true,
    isPrivate: true,
    is2FaProtected: true,
    component: ProfileSettings,
  },
  {
    path: '/profile/2fa-settings',
    isExact: true,
    isPrivate: true,
    is2FaProtected: true,
    component: TwoFactorAuthSettings,
  },
  {
    path: '/profile/2fa-activate',
    isExact: true,
    isPrivate: true,
    is2FaProtected: false,
    component: TwoFactorAuthActivate,
  },
  {
    path: '/404',
    isExact: true,
    isPrivate: false,
    is2FaProtected: false,
    component: NotFound,
  },
  {
    path: '/clear-cache',
    isExact: true,
    isPrivate: false,
    is2FaProtected: false,
    component: ClearCacheComponent,
  },
];

export default routes;
